if (!customElements.get('product-form')) {

  customElements.define(
    'product-form',

    class ProductForm extends HTMLElement {

      constructor() {

        super();

        this.form = this.querySelector('form');

        if (this.form) {

          const variantInput =
            this.form.querySelector('[name=id]');

          if (variantInput) {
            variantInput.disabled = false;
          }

          this.form.addEventListener(
            'submit',
            this.onSubmitHandler.bind(this)
          );

        } else {

          return;
        }

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) {

          if (this.submitButton) {

            this.submitButton.setAttribute(
              'aria-haspopup',
              'dialog'
            );
          }
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {

        evt.preventDefault();

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        this.querySelector('.loading-overlay__spinner')
          .classList.remove('hidden');

        const config =
          fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData =
          new FormData(this.form);

        // ==========================================
        // GET CART TYPE
        // ==========================================

        const cartType =
          window.themeSettings?.cart_type ||
          'drawer';

        // ==========================================
        // ONLY APPEND SECTIONS FOR DRAWER/NOTIFICATION
        // ==========================================

        if (
          this.cart &&
          (
            cartType === 'drawer' ||
            cartType === 'notification'
          )
        ) {

          formData.append(
            'sections',
            this.cart.getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)

          .then((response) => response.json())

          .then((response) => {

            // ==========================================
            // ERROR
            // ==========================================

            if (response.status) {

              publish(PUB_SUB_EVENTS.cartError, {

                source: 'product-form',

                productVariantId:
                  formData.get('id'),

                errors:
                  response.errors ||
                  response.description,

                message:
                  response.message
              });

              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) return;

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButton
                .querySelector('span')
                .classList.add('hidden');

              soldOutMessage
                .classList.remove('hidden');

              this.error = true;

              return;
            }

            // ==========================================
            // SILENT QUICK ADD
            // ==========================================

            if (cartType === 'silent') {

              // ==========================================
              // UPDATE CART COUNT + TOTAL
              // ==========================================

              fetch(`${routes.cart_url}.js`)

                .then((res) => res.json())

                .then((cart) => {

                  // =========================
                  // UPDATE COUNT
                  // =========================

                  const cartCountElements =
                    document.querySelectorAll(
                      '.wbhcartitem'
                    );

                  cartCountElements.forEach((element) => {

                    element.textContent =
                      cart.item_count;
                  });

                  // =========================
                  // UPDATE TOTAL
                  // =========================

                  const totalElements =
                    document.querySelectorAll(
                      '.wbcarthtotal span'
                    );

                  totalElements.forEach((element) => {

                    element.innerHTML =
                      Shopify.formatMoney(
                        cart.total_price,
                        window.money_format
                      );
                  });

                  // =========================
                  // UPDATE QTY TITLE
                  // =========================

                  const qtyTitle =
                    document.querySelector(
                      '.qty_title strong:last-child'
                    );

                  if (qtyTitle) {

                    qtyTitle.textContent =
                      `(${cart.item_count})`;
                  }
                });

              // ==========================================
// UPDATE HEADER MINI CART
// ==========================================

fetch('/?section_id=header')
  .then((res) => res.text())
  .then((responseText) => {

    const html =
      new DOMParser().parseFromString(
        responseText,
        'text/html'
      );

    // =========================
    // MINI CART ITEMS
    // =========================

    const newItems =
      html.querySelector(
        '#webi-main-cart-items .js-contents'
      );

    const currentItems =
      document.querySelector(
        '#webi-main-cart-items .js-contents'
      );

    if (newItems && currentItems) {

      currentItems.innerHTML =
        newItems.innerHTML;

        // =========================
// RE-INITIALIZE QUANTITY BUTTONS
// =========================

document.querySelectorAll(
  'webi-quantity-input'
).forEach((quantityInput) => {

  const input =
    quantityInput.querySelector('input');

  const plusButton =
    quantityInput.querySelector(
      'button[name="plus"]'
    );

  const minusButton =
    quantityInput.querySelector(
      'button[name="minus"]'
    );

  const updateCart = (newQty) => {

    fetch('/cart/change.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json'
      },

      body: JSON.stringify({

        line: input.dataset.index,
        quantity: newQty
      })
    })

    .then((res) => res.json())

    .then(() => {

      // RELOAD HEADER CART

      fetch('/?section_id=header')

        .then((res) => res.text())

        .then((responseText) => {

          const html =
            new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

          // ITEMS

          const newItems =
            html.querySelector(
              '#webi-main-cart-items .js-contents'
            );

          const currentItems =
            document.querySelector(
              '#webi-main-cart-items .js-contents'
            );

          if (newItems && currentItems) {

            currentItems.innerHTML =
              newItems.innerHTML;
          }

          // FOOTER

          const newFooter =
            html.querySelector(
              '#webi-main-cart-footer'
            );

          const currentFooter =
            document.querySelector(
              '#webi-main-cart-footer'
            );

          if (newFooter && currentFooter) {

            currentFooter.replaceWith(
              newFooter
            );
          }

          // COUNT

          fetch('/cart.js')

            .then((res) => res.json())

            .then((cart) => {

              document
                .querySelectorAll('.wbhcartitem')
                .forEach((el) => {

                  el.textContent =
                    cart.item_count;
                });

              document
                .querySelectorAll('.wbcarthtotal span')
                .forEach((el) => {

                  el.innerHTML =
                    Shopify.formatMoney(
                      cart.total_price,
                      window.money_format
                    );
                });
            });
        });
    });
  };

  if (plusButton) {

    plusButton.onclick = () => {

      input.stepUp();

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    };
  }

  if (minusButton) {

    minusButton.onclick = () => {

      input.stepDown();

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    };
  }
});
    }

    // =========================
    // MINI CART FOOTER
    // =========================

    const newFooter =
  html.querySelector(
    '#webi-main-cart-footer'
  );

const currentFooter =
  document.querySelector(
    '#webi-main-cart-footer'
  );

if (newFooter && currentFooter) {

  currentFooter.replaceWith(
    newFooter
  );
}

    // =========================
    // EMPTY CART CLASS
    // =========================

    const cartWrapper =
      document.querySelector('webi-cart-items');

    if (cartWrapper) {

      if (currentItems.innerHTML.trim() === '') {

        cartWrapper.classList.add('is-empty');

      } else {

        cartWrapper.classList.remove('is-empty');
      }
    }
  });

              // ==========================================
              // BUTTON SUCCESS TEXT
              // ==========================================

              if (this.submitButtonText) {

                const originalText =
                  this.submitButtonText.textContent;

                this.submitButtonText.textContent =
                  'Added ✓';

                setTimeout(() => {

                  this.submitButtonText.textContent =
                    originalText;

                }, 1500);
              }

              // ==========================================
              // PUBLISH EVENT
              // ==========================================

              publish(PUB_SUB_EVENTS.cartUpdate, {

                source: 'product-form',

                productVariantId:
                  formData.get('id'),

                cartData: response
              });

              return;
            }

            // ==========================================
            // PAGE REDIRECT
            // ==========================================

            if (
              !this.cart ||
              cartType === 'page'
            ) {

              window.location =
                window.routes.cart_url;

              return;
            }

            // ==========================================
            // DRAWER / NOTIFICATION
            // ==========================================

            if (!this.error) {

              publish(PUB_SUB_EVENTS.cartUpdate, {

                source: 'product-form',

                productVariantId:
                  formData.get('id'),

                cartData: response
              });
            }

            this.error = false;

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {

              document.body.addEventListener(

                'modalClosed',

                () => {

                  setTimeout(() => {

                    this.cart.renderContents(
                      response
                    );

                  });
                },

                { once: true }
              );

              quickAddModal.hide(true);

            } else {

              this.cart.renderContents(
                response
              );
            }
          })

          .catch((e) => {

            console.error(e);
          })

          .finally(() => {

            this.submitButton
              .classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {

              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {

              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            this.querySelector(
              '.loading-overlay__spinner'
            ).classList.add('hidden');
          });
      }

      handleErrorMessage(
        errorMessage = false
      ) {

        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {

          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {

        if (!this.submitButton) return;

        if (disable) {

          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {

            this.submitButtonText.textContent =
              text;
          }

        } else {

          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {

        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}